<template lang="pug">
el-dialog.modal-upload-laudos-em-lote(
    :visible.sync='show',
    :close-on-click-modal='false',
    :destroy-on-close='true',
    :before-close='fechar',
    :show-close='true',
    :close-on-press-escape='closeOnEsc',
    width='50%'
)
    template(slot='title')
        .modal-upload-laudos-em-lote__titulo {{ $t('mensagens.laudos.renovabio.modalUploadLote.tituloModal') }}

    section
        .mb-2
            span.mr-2(style='color: red') *
            span.font-weight-bold(
                v-html='$t("mensagens.laudos.renovabio.modalUploadLote.textoCorpoModal1")'
            )
        ul
            li.mb-2(
                v-html='$t("mensagens.laudos.renovabio.modalUploadLote.textoCorpoModal2")'
            )
            li.mb-2(
                v-html='$t("mensagens.laudos.renovabio.modalUploadLote.textoCorpoModal4")'
            )
            li.mb-2(
                v-html='$t("mensagens.laudos.renovabio.modalUploadLote.textoCorpoModal5")'
            )
            li.mb-2(
                v-html='$t("mensagens.laudos.renovabio.modalUploadLote.textoCorpoModal6")'
            )
            li.mb-2(
                v-html='$t("mensagens.laudos.renovabio.modalUploadLote.textoCorpoModal7")'
            )

        el-alert.mb-3.px-4(
            :title='$t("mensagens.laudos.renovabio.modalUploadLote.textoCorpoModalAlert")',
            type='warning',
            :closable='false',
            show-icon
        )

        .mb-2 {{ $t('mensagens.laudos.renovabio.modalUploadLote.textoCorpoModal3') }}
            BaseButton.ml-1(
                style='font-weight: bold',
                type='text',
                icon='el-icon-download',
                @click='downloadModeloPlanilha'
            ) {{ $t('mensagens.laudos.renovabio.modalUploadLote.baixarPlanilhaModelo') }}

        section(v-show='arquivoEscolhido.length === 0')
            el-upload.mb-2(
                action='#',
                :auto-upload='false',
                :on-change='enviarPlanilha',
                :on-exceed='onExceed',
                :file-list='fileList',
                :limit='1',
                drag,
                ref='refUploadLaudosEmLote'
            )
                i.el-icon-upload
                .el-upload__text(
                    v-html='$t("mensagens.laudos.renovabio.modalUploadLote.textoDisclaimer1")'
                )
                span.el-upload__formats {{ $t('mensagens.laudos.renovabio.modalUploadLote.textoDisclaimer2') }}

        .tabelaProcessamento(v-if='arquivoEscolhido.length > 0')
            el-table(
                height='100%',
                :data='arquivoEscolhido',
                style='width: 100%'
            )
                el-table-column(
                    prop='planilha_importada',
                    :label='$t("mensagens.laudos.renovabio.modalUploadLote.tabelaColuna1")'
                )

                el-table-column(
                    prop='status',
                    :label='$t("mensagens.laudos.renovabio.modalUploadLote.tabelaColuna2")'
                )
                    template(slot-scope='scope')
                        el-tag(:type='scope.row.status.type', size='medium')
                            el-icon.mr-2(:class='scope.row.status.icon')
                            | {{ scope.row?.status?.nome }}

                el-table-column(
                    prop='qtdeCars',
                    v-if='arquivoEscolhido[0].status.id === 3',
                    :label='$t("mensagens.laudos.renovabio.modalUploadLote.tabelaColuna4")'
                )
                    template(slot-scope='scope')
                        span(v-if='arquivoEscolhido[0].status.id === 3') {{ qtdeCars || '--' }}

                el-table-column(
                    v-if='arquivoEscolhido[0].status.id === 2',
                    prop='planilha_com_erro',
                    :label='$t("mensagens.laudos.renovabio.modalUploadLote.tabelaColuna3")'
                )
                    template(slot-scope='scope')
                        BaseButton(
                            icon='el-icon-download',
                            type='primary',
                            size='mini',
                            @click='downloadArquivoErro'
                        ) {{ $t('mensagens.laudos.renovabio.modalUploadLote.fazerDownload') }}

        section(
            v-if='arquivoEscolhido.length > 0 && arquivoEscolhido[0].status.id === 2'
        )
            .mt-3(
                v-html='$t("mensagens.laudos.renovabio.modalUploadLote.textoPlanilhaComErro")'
            )

    template(slot='footer')
        .d-flex.justify-content-between
            BaseButton(@click='fechar')
                span
                    | {{ $t('mensagens.comuns.sair') }}
            BaseButton(
                type='primary',
                :disabled='desabilitarConfirmar || (arquivoEscolhido.length > 0 && arquivoEscolhido[0].status.id === 3 && Number(qtdeCars) === 0)',
                @click='solicitarLaudosEmLote'
            )
                | {{ $t('mensagens.comuns.finalizar') }}
</template>

<script>
import LaudosService from '@/services/LaudosService';
import AuthService from '@/services/AuthService';
import * as XLSX from 'xlsx';
import { mapState, mapGetters } from 'vuex';
import { retryOperation } from '@/utils/retry-operation';
import { connect, subscribe, disconnect } from '@/utils/websocket';
import TipoLaudo from '@/constants/TipoLaudo';
import store from '@/store';
import BaseButton from '@/components/vegaComponents/BaseButton.vue';

export default {
    name: 'ModalUploadLaudosEmLote',

    components: {
        BaseButton
    },

    emits: ['atualizar'],

    props: {
        show: {
            type: Boolean,
            required: true,
            default: false
        }
    },

    data() {
        return {
            arquivoEscolhido: [],
            arquivoHash: null,
            planilhaResultados: null,
            carsNovos: [],
            decisaoUsuario: 'todos',
            desabilitarConfirmar: true,
            timeoutEvitarLogOff: null,
            status: [
                {
                    id: 1,
                    nome: this.$t('mensagens.operacao.uploadEmProcessamento'),
                    type: 'info',
                    icon: 'el-icon-loading'
                },
                {
                    id: 2,
                    nome: this.$t('mensagens.operacao.processadoComErro'),
                    type: 'danger',
                    icon: 'el-icon-warning-outline'
                },
                {
                    id: 3,
                    nome: this.$t('mensagens.operacao.processadoComSucesso'),
                    type: 'success',
                    icon: 'el-icon-circle-check'
                }
            ],
            qtdeCars: 0,
            fileList: [],
            closeOnEsc: true,
            closedModalConfirmacao: false,
            modeloPlanilha:
                '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'
        };
    },

    computed: {
        ...mapState(['usuarioLogado']),
        ...mapGetters([
            'emProcessamentoUploadLoteRenovabio',
            'emProcessamentoDownloadLoteRenovabio'
        ])
    },

    beforeDestroy() {
        if (!this.emProcessamentoUploadLoteRenovabio && !this.emProcessamentoDownloadLoteRenovabio) {
            disconnect();
        }
    },

    methods: {
        downloadModeloPlanilha() {
            const linkSource = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${this.modeloPlanilha}`;
            const link = document.createElement('a');
            const fileName = 'Modelo_xlsx_laudos_renovabio.xlsx';
            link.href = linkSource;
            link.download = fileName;
            link.click();
            link.remove();
        },

        loopingTimeout() {
            this.timeoutEvitarLogOff = setInterval(() => {
                this.buscarDadosUsuarioLogado();
            }, 120000);
        },

        async buscarDadosUsuarioLogado() {
            await AuthService.buscarDadosUsuarioLogado(false);
        },

        async verificarJaCadastrados(planilha) {
            try {
                LaudosService.verificarTipoArquivo(planilha).then(async resposta => {
                    if (resposta.data) {
                        const dadosPlanilha = await this.lerArquivoXLSX(
                            planilha
                        );
                        const response =
                            await LaudosService.verificarLaudosNovos(
                                dadosPlanilha.slice(1),
                                TipoLaudo.RENOVABIO
                            );
                        const dados = response.data;
                        this.carsNovos = dados.cars;

                        if (dados.quantidadeDuplicados > 0) {
                            this.$emit(
                                'carJaCadastradosEncontrados',
                                dados.quantidadeDuplicados
                            );
                        } else {
                            this.processarPlanilha(this.planilhaResultados);
                        }
                    } else {
                        this.$notify.error({ message: this.$t('mensagens.laudos.renovabio.modalUploadLote.planilhaForaPadrao'), duration: 10000 });
                        this.limpar();
                    }
                }).catch(erro => {
                    this.$notify.error({ message: erro.response.data.message });
                    return false;
                });
                
            } catch (error) {
                this.$notify.error({ message: error });
            }
        },

        prosseguirBaseadoNaDecisao(decisao) {
            if (decisao === 'todos') {
                this.processarPlanilha(this.planilhaResultados);
            } else if (decisao === 'novos') {
                this.processarPlanilha(
                    this.planilhaResultados,
                    this.carsNovos
                );
            } else if (decisao === 'cancelar') {
                this.$refs.refUploadLaudosEmLote.clearFiles();
            }
        },

        s2ab(s) {
            const buf = new ArrayBuffer(s.length);
            const view = new Uint8Array(buf);
            for (let i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xff;
            return buf;
        },

        async processarPlanilha(planilha, carsNovos) {
            try {
                let dadosPlanilha = await this.lerArquivoXLSX(planilha);

                if (carsNovos && dadosPlanilha.length > 0) {
                    const cabecalho = dadosPlanilha.slice(0, 1)[0];

                    if (carsNovos.length === 0) {
                        this.$refs.refUploadLaudosEmLote.clearFiles();
                        this.$notify.warning({
                            message: this.$t(
                                'mensagens.laudos.renovabio.naoHaNovosCarsParaProcessar'
                            )
                        });
                        return;
                    }

                    carsNovos.unshift(cabecalho);
                    const dadosNovaPlanilha = carsNovos.map(item => {
                        return [
                            item.car,
                            item.ano,
                            item.cpfCnpjProdutorBiomassa || '',
                            item.nomeRazaoSocialProdutorBiomassa || ''
                        ];
                    });

                    let novaPlanilha = XLSX.utils.book_new();
                    let novaAba = XLSX.utils.aoa_to_sheet(dadosNovaPlanilha);
                    XLSX.utils.book_append_sheet(
                        novaPlanilha,
                        novaAba,
                        'Filtrada'
                    );

                    const wbout = XLSX.write(novaPlanilha, {
                        bookType: 'xlsx',
                        type: 'binary'
                    });
                    const blob = new Blob([this.s2ab(wbout)], {
                        type: 'application/octet-stream'
                    });

                    let novoArquivo = new File(
                        [blob],
                        'PlanilhaFiltrada.xlsx',
                        {
                            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                        }
                    );

                    let planilhaCompativel = {
                        name: novoArquivo.name,
                        percentage: 0,
                        raw: novoArquivo,
                        uid: Date.now(),
                        size: novoArquivo.size,
                        status: 'ready'
                    };

                    this.planilhaResultados = planilhaCompativel;
                }

                this.arquivoEscolhido.push({
                    planilha_importada: planilha?.name,
                    status: this.status[0]
                });

                subscribe(
                    `${this.usuarioLogado.idKeyCloack}/laudo/carregamento-planilha`,
                    response => {
                        const data = JSON.parse(response);
                        if (response && data?.status === 'VALIDO') {
                            this.arquivoEscolhido[0].status = this.status[2];
                            this.desabilitarConfirmar = false;
                            this.arquivoHash = data?.hash;
                            this.qtdeCars = data?.qtdeCars;
                            clearInterval(this.timeoutEvitarLogOff);

                            if (this.closedModalConfirmacao === false) {
                                this.$notify.success({
                                    message: this.$t(
                                        'mensagens.operacao.notificacao.sucessoNoArquivo'
                                    )
                                });
                            }
                        } else {
                            this.arquivoEscolhido[0].status = this.status[1];
                            this.arquivoHash = data?.hash;
                            clearInterval(this.timeoutEvitarLogOff);

                            this.$notify.warning({
                                message: this.$t(
                                    'mensagens.operacao.notificacao.arquivoComErro'
                                )
                            });
                        }
                        disconnect();
                    }
                );

                await retryOperation(
                    LaudosService.uploadPlanilha,
                    this.planilhaResultados,
                    5000,
                    10
                );
            } catch (error) {
                this.desabilitarConfirmar = false;
                clearInterval(this.timeoutEvitarLogOff);
                this.$notify.error({
                    message: this.$t(
                        'mensagens.operacao.notificacao.uploadErro'
                    )
                });
                setTimeout(() => this.limpar(), 1000);
            }
        },

        async lerArquivoXLSX(planilha) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onload = async e => {
                    try {
                        const data = e.target.result;
                        const workbook = XLSX.read(data, { type: 'binary' });
                        const firstSheetName = workbook.SheetNames[0];
                        const worksheet = workbook.Sheets[firstSheetName];
                        const json = XLSX.utils.sheet_to_json(worksheet, {
                            header: 1
                        });

                        const cabecalho = {
                            car: json[0][0],
                            ano: json[0][1],
                            cpfCnpjProdutorBiomassa: json[0][2],
                            nomeRazaoSocialProdutorBiomassa: json[0][3]
                        };
                        let dadosPlanilha = json
                            .map(row => {
                                return {
                                    car: row[0],
                                    ano: row[1],
                                    cpfCnpjProdutorBiomassa: row[2],
                                    nomeRazaoSocialProdutorBiomassa: row[3]
                                };
                            })
                            .slice(1);
                        dadosPlanilha.unshift(cabecalho);
                        resolve(dadosPlanilha);
                    } catch (error) {
                        reject(error);
                    }
                };
                reader.onerror = error => {
                    reject(error);
                };
                reader.readAsBinaryString(planilha.raw);
            });
        },

        async enviarPlanilha(planilha) {
            this.planilhaResultados = planilha;
            if (this.arquivoEscolhido.length > 0) {
                this.$notify.warning({
                    message: this.$t(
                        'mensagens.operacao.notificacao.enviarPlanilha'
                    )
                });
                this.$refs.refUploadLaudosEmLote.clearFiles();
                return;
            }

            if (planilha.size > 15000000) {
                this.$notify.warning({
                    message: this.$t(
                        'mensagens.operacao.notificacao.ultrapassa15MB'
                    )
                });
                this.$refs.refUploadLaudosEmLote.clearFiles();
                return false;
            }

            let extension = planilha.name.split('.').pop().toLowerCase();
            if (extension !== 'xlsx' && extension !== 'xls') {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.operacao.notificacao.tipoNaoSuportado'
                    )
                });
                this.$refs.refUploadLaudosEmLote.clearFiles();
                return false;
            }

            try {
                await connect();
            } catch {
                this.$notify.error({
                    message: this.$t('mensagens.operacao.notificacao.apiOff')
                });
                return;
            }

            if (this.usuarioLogado) {
                this.loopingTimeout();

                await this.verificarJaCadastrados(this.planilhaResultados);
                
            } else {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.diagnosticoSocioambiental.erro.usuarioDeslogado'
                    )
                });
                clearInterval(this.timeoutEvitarLogOff);
                disconnect();
                setTimeout(() => this.limpar(), 100);
            }
        },

        async downloadArquivoErro() {
            await LaudosService.downloadPlanilhaErro(this.arquivoHash + '.' +
                this.arquivoEscolhido[0].planilha_importada.split('.').pop())
                .then(() => {
                    this.$notify.success({
                        message: this.$t(
                            'mensagens.operacao.notificacao.downloadRealizado'
                        )
                    });
                })
                .catch(() =>
                    this.$notify.error({
                        message: this.$t(
                            'mensagens.operacao.notificacao.downloadErro'
                        )
                    })
                );
        },

        onExceed() {
            this.$notify.warning({
                message: this.$t(
                    'mensagens.menuMapa.planilha.observacoes.erro.3'
                ),
                position: 'top-left'
            });
        },

        async solicitarLaudosEmLote() {
            if (this.emProcessamentoUploadLoteRenovabio || this.emProcessamentoDownloadLoteRenovabio) {
                this.$notify.warning({
                    message: this.$t(
                        'mensagens.laudos.renovabio.laudoEmLoteEmProcessamentoAsync'
                    )
                });
                return;
            }
            store.dispatch('setEmProcessamentoUploadLoteRenovabio', true);
            store.dispatch('setHashPlanilhaRenovabio', this.arquivoHash + '.' +
                this.arquivoEscolhido[0].planilha_importada.split('.').pop());

            this.limpar();
            this.$emit('fechar');
        },

        limpar() {
            this.arquivoEscolhido = [];
            this.arquivoHash = null;
            this.closedModalConfirmacao = false;
            this.desabilitarConfirmar = true;
            this.$refs.refUploadLaudosEmLote.clearFiles();
        },

        fechar() {
            if (
                (this.arquivoEscolhido.length > 0 &&
                    this.arquivoEscolhido[0].status.id === 3) ||
                (this.arquivoEscolhido.length > 0 &&
                    this.arquivoEscolhido[0].status.id === 1)
            ) {
                this.fecharUploadAndamento();
            } else {
                this.$emit('fechar');
                setTimeout(() => this.limpar(), 1000);
            }
        },

        async fecharUploadAndamento() {
            await this.$messageBox
                .confirm(
                    this.$t(
                        'mensagens.laudos.renovabio.modalUploadLote.desejaCancelarUploadLaudo'
                    ),
                    this.$t(
                        'mensagens.laudos.renovabio.modalUploadLote.tituloModalCancelarAndamentoLaudos'
                    ),
                    {
                        dangerouslyUseHTMLString: true,
                        confirmButtonText: this.$t(
                            'mensagens.comuns.continuarSolicitacao'
                        ),
                        cancelButtonText: this.$t('mensagens.comuns.sair')
                    }
                )
                .then(() => {})
                .catch(() => {
                    this.closedModalConfirmacao = true;
                    this.$emit('fechar');
                    setTimeout(() => this.limpar(), 1000);
                });
        }
    }
};
</script>

<style lang="scss">
.modal-upload-laudos-em-lote {
    .modal-upload-laudos-em-lote__titulo {
        font-weight: bold;
        color: #00413c;
        font-size: 18px;
    }

    .el-dialog__body {
        padding: 20px !important;
        word-break: keep-all;
        word-wrap: break-word;

        ul {
            padding-left: 25px;
        }

        .el-alert__title {
            font-size: 14px !important;
            font-weight: 500;
            line-height: 20px;
            letter-spacing: 0em;
            text-align: left;
            color: #3b3b3b;
        }
    }

    .el-dialog__header {
        padding-bottom: 20px !important;
        background: #e9e9e9;
    }

    .el-dialog__footer {
        padding-top: 20px !important;
        border-top: 1px solid #e9e9e9;
    }

    .el-dialog {
        background: white !important;
    }

    .el-upload__text {
        font-size: 14px;
        font-weight: 400;
        line-height: 17px;
        letter-spacing: 0em;
        margin-bottom: 8px;

        em {
            color: #276fda !important;
        }
    }

    .el-upload__formats {
        font-size: 12px;
        font-weight: 400;
        line-height: 15px;
        letter-spacing: 0em;
    }

    .el-upload-dragger {
        width: 100%;
        height: 190px !important;
    }
    .el-dialog__footer > div > button.el-button.el-button--default {
        border: 1px solid var(--primary);
    }
}
.el-message-box__btns
    > button.el-button.el-button--default.el-button--small.el-button--primary {
    background-color: var(--primary);
    border-color: var(--primary);
    color: var(--white);
}
.el-message-box__btns
    > button.el-button.el-button--default.el-button--small.el-button--primary:hover {
    background-color: var(--secondary);
    border-color: var(--secondary);
    color: var(--color-button-hover);
    outline: 0px auto var(--secondary);
}
.el-message-box__wrapper > div > div.el-message-box__btns {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}
.el-message-box__btns > button:nth-child(1) {
    border: 1px solid var(--primary);
}
.el-message-box__btns > button {
    width: auto !important;
}
.tabelaProcessamento {
    height: 200px;
}
</style>
